import { render } from "./NewsWriteView.vue?vue&type=template&id=62c1fe28&scoped=true"
import script from "./NewsWriteView.vue?vue&type=script&lang=js"
export * from "./NewsWriteView.vue?vue&type=script&lang=js"

import "./NewsWriteView.vue?vue&type=style&index=0&id=62c1fe28&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c1fe28"]])

export default __exports__